import {
  Drawer,
  Box,
  IconButton,
  Grid,
  Card,
  CardContent,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Thermostat,
  Opacity,
  Co2,
  Science,
  VolumeUp,
  Air,
  FilterAlt,
  Cloud,
  Yard
} from '@mui/icons-material';

/**
 * DashboardSlider: right-hand drawer displaying metric cards.
 * Props:
 * - open: boolean
 * - onClose: func
 * - realTimeData: object mapping device IDs to data objects
 * - selectedDevice: string
 * - selectedTable: string
 */
const DashboardSlider = ({ open, onClose, realTimeData, selectedDevice, selectedTable }) => {
  // Get data for the currently selected device
  const selectedData = realTimeData[selectedDevice] || {};

  // Define metrics based on selected table
  const metrics = selectedTable === 'aquacheck'
    ? [
        { id: 'temperature', title: 'Température', unit: '°C', icon: Thermostat, color: '#FF5722', getValue: data => data.temperature },
        { id: 'humidity', title: 'Humidité', unit: '%', icon: Opacity, color: '#00FF00', getValue: data => data.humidity },
        { id: 'ground_humidity', title: 'Humidité du Sol', unit: '%', icon: Yard, color: '#CD18DE', getValue: data => data.ground_humidity }
      ]
    : [
        { id: 'temperature', title: 'Température', unit: '°C', icon: Thermostat, color: '#FF5722', getValue: data => data.temperature },
        { id: 'humidity', title: 'Humidité', unit: '%', icon: Opacity, color: '#00FF00', getValue: data => data.humidity },
        { id: 'co2', title: 'CO2', unit: 'ppm', icon: Co2, color: '#0000FF', getValue: data => data.co2 },
        { id: 'tvoc', title: 'TVOC', unit: 'ppb', icon: Science, color: '#FFFF00', getValue: data => data.tvoc },
        { id: 'sound_level', title: 'Niveau Sonore', unit: 'dB', icon: VolumeUp, color: '#F39C12', getValue: data => data.sound_level },
        { id: 'pm1_0', title: 'PM1.0', unit: 'µg/m³', icon: Air, color: '#8E44AD', getValue: data => data.pm1_0 },
        { id: 'pm2_5', title: 'PM2.5', unit: 'µg/m³', icon: FilterAlt, color: '#16A085', getValue: data => data.pm2_5 },
        { id: 'pm10', title: 'PM10', unit: 'µg/m³', icon: Cloud, color: '#F39C12', getValue: data => data.pm10 }
      ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: '80%', sm: 360 }, backgroundColor: '#141526', color: '#fff' } }}
    >
      {/* Drawer Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Métriques en direct
        </Typography>
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Metrics Grid */}
      <Box sx={{ p: 2, overflowY: 'auto', height: 'calc(100% - 64px)' }}>
        <Grid container spacing={2}>
          {metrics.map(metric => {
            const Icon = metric.icon;
            return (
              <Grid item xs={12} sm={6} key={metric.id}>
                <Card sx={{ backgroundColor: '#1e1e2f', borderRadius: 2 }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Icon sx={{ fontSize: 28, color: metric.color }} />
                      <Typography variant="subtitle2" sx={{ ml: 1 }}>
                        {metric.title}
                      </Typography>
                    </Box>
                    <Typography variant="h5" sx={{ color: '#fff' }}>
                      {metric.getValue(selectedData) ?? '...'} {metric.unit}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Drawer>
  );
};

export default DashboardSlider;
